import React from 'react';

import { useMediaQuery } from '@common/hooks';

import AdvanceFilter from '@alumni_v2/ui/Filters/AdvanceFilter';
import QuickFilters from '@alumni_v2/ui/Filters/QuickFilters';

import styles from './Filters.module.scss';

function Filters() {
  const { filterOptions, quickFilters } = window.__INITIAL_STATE__;
  const { tablet } = useMediaQuery();

  return (
    <>
      <div
        role="button"
        tabIndex={-1}
        className={`${tablet ? styles.mobileFilter : styles.filters}`}
      >
        <div className={
          `${tablet ? styles.mobileAdvanceFilter : styles.advanceFilter}`
        }
        >
          <AdvanceFilter filterOptions={filterOptions} />
        </div>

        <div className={
          `${tablet ? styles.mobileQuickFilter : styles.quickFilterContainer
          }`
        }
        >
          <QuickFilters quickFilters={quickFilters} />
        </div>
      </div>
    </>
  );
}

export default Filters;
